import DataCollectionSDK from '@/docs-partials/sdk/data-collection.mdx';
import * as React from 'react';
export default {
  DataCollectionSDK,
  React
};